export const cols = [{
	prop: 'createDate',
	label: '时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'tel',
	label: '客户账号',
	width: '140',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerCategoryName',
	label: '客户类别',
	width: '140',
	ischoose: false,
	align: 'center'
}, {
	prop: 'shopName',
	label: '店铺名称',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'prePaymentType',
	label: '充值类型',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'money',
	label: '金额',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'realpremoney',
	label: '可用余额（前）',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'realpremoneyafter',
	label: '可用余额（后）',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'costMoney',
	label: '充值金额',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'giftMoney',
	label: '赠送金额',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderNumber',
	label: '单据号',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'serialnumber',
	label: '流水号',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentserialnumber',
	label: '第三方流水号',
	width: '200',
	ischoose: false,
	align: 'center'
}, {
	prop: 'remarks',
	label: '备注',
	width: '200',
	ischoose: false,
	align: 'center'
}]
